import { useState, useEffect } from 'react';
import './ConfirmDialog.css';

function ConfirmDialog({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  requireTextConfirmation = false,
  confirmationText = 'confirm'
}) {
  const [inputValue, setInputValue] = useState('');
  const [isValid, setIsValid] = useState(false);

  // Reset input when dialog opens
  useEffect(() => {
    if (isOpen) {
      setInputValue('');
      setIsValid(false);
    }
  }, [isOpen]);

  // Check if input matches required text
  useEffect(() => {
    setIsValid(inputValue === confirmationText);
  }, [inputValue, confirmationText]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!requireTextConfirmation || isValid) {
      onConfirm();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>
        
        {requireTextConfirmation && (
          <div className="text-confirmation-container">
            <p className="confirmation-instruction">
              Please type <strong>{confirmationText}</strong> to confirm:
            </p>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="confirmation-input"
              placeholder={`Type "${confirmationText}"`}
            />
          </div>
        )}
        
        <div className="confirm-dialog-actions">
          <button className="cancel-btn" onClick={onCancel}>Cancel</button>
          <button 
            className={`confirm-btn ${requireTextConfirmation && !isValid ? 'disabled' : ''}`} 
            onClick={handleConfirm}
            disabled={requireTextConfirmation && !isValid}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog; 